(function(_){
    'use strict';
    _['CART.KEY']='Carrinho';
    _['CART.CONFIRM']='Confirmar';
    _['CART.NEXT']='Seguinte';
    _['CART.EMPTY-CART']='O carrinho está vazio!';
    _['CART.ADDRESS']='Endereço';
    _['CART.ORDER']='Pedido';
    _['CART.PAYMENT']='Pagamento';
    _['CART.PRODUCT-ADDED']='{0} produtos adicionados ao carrinho';
    _['CART.PRODUCT-ADDED(1)']='{0} produto adicionado ao carrinho';
    _['CART.GO-TO-CART']='Ir para o carrinho';
    _['CART.CONTINUE']='Continuar';
    _['CART.AMOUNT']='Quantidade';
    _['CART.PRICE']='Preço';
    _['CART.TOTAL']='Total';

    _['CART.ORDER.REMOVE']='Eliminar produto';
    _['CART.ORDER.PRICES.TITLE']='Resumo da tua compra';
    _['CART.ORDER.PRICES.TOTAL']='Preço';
    _['CART.ORDER.PRICES.TAXES']='IVA';
    _['CART.ORDER.PRICES.SHIPPING-CHARGES']='Portes de envio';
    _['CART.ORDER.PRICES.TOTALWITHTAXES']='Total';
    _['CART.ORDER.PRICES.TOTALWITHTAXESUSD']='Total (USD)';
    _['CART.ORDER.PRICES.WARNING.TEXT']='Esta moeda não é suportada pelo PayPal. Tem em atenção que a cobrança será feita em EUR e que o teu banco calculará a taxa de câmbio final.';

    _['CART.STOCK-STATUS']='Níveis de Stock';
    _['CART.STOCK-STATUS.OK']='OK';
    _['CART.STOCK-STATUS.OK.DESC']='Todos os produtos estão em stock.';
    _['CART.STOCK-STATUS.ERR']='Erro';
    _['CART.STOCK-STATUS.ERR.DESC']='Alguns produtos estão fora de stock/ algum dos produtos está fora de stock';
    _['CART.FINAL-PRICE']='Preço final';
    _['CART.ORDER.REMOVAL-CONFIRM.TITLE']='Retirar produto do carrinho';
    _['CART.ORDER.REMOVAL-CONFIRM.MSG']='Tem a certeza?';
    _['CART.ADDRESS.EDIT']='Editar';
    _['CART.ADDRESS.SHIPPING']='Endereço de envio';
    _['CART.ADDRESS.BILLING']='Endereço de faturação';
    _['CART.ADDRESS.OBSERVATIONS']='Observações';
    _['CART.ADDRESS.PAYMENT_MODEL']='Método de pagamento';
    _['CART.ADDRESS.PAY_WITH_REDSYS']='Pagar agora com Cartão de crédito';
    _['CART.ADDRESS.PAY_WITH_PICK_AT_STORE']='Pague quando você pegar na loja';
    _['CART.ADDRESS.PAY_WITH_PAYPAL']='Pagar agora com PayPal';
    _['CART.ADDRESS.PAY_WITH_REFUND']='Pagar em dinheiro na entrega';
    _['CART.ADDRESS.PAY_WITH_WIRE_TRANSFER']='Pagar por transferência bancária';

    _['CART.ADDRESS.NO.PAYMENT_MODEL.MSG']='Não há nenhum método de pagamento configurado. Contata o administrador da app.';

    _['CART.ADDRESS.SAME-AS-SHIPPING']='Igual ao Endereço de envio';

    _['CART.PAYMENT.PAYPAL.ADVICE']='Serás redirecionado para a página do Paypal para realizar o pagamento.';
    _['CART.PAYMENT.PAYPAL.REDIRECTING']='Redirecionando para Paypal';
    _['CART.PAYMENT.PAYPAL.BTN']='¡Realizar o pagamento!';
    _['CART.PAYMENT.REFUND.ADVICE']='Confirma o pagamento do teu pedido. Analisa cuidadosamente todos os teus dados e pressione o botão "Confirmar pedido!".';
    _['CART.PAYMENT.REFUND.REDIRECTING']='Confirmar pedido';
    _['CART.PAYMENT.REFUND.BTN']='Confirmar pedido!';
    _['CART.PAYMENT.WIRE_TRANSFER.ADVICE']='Confirma o pagamento do teu pedido. Analisa cuidadosamente todos os teus dados e pressione o botão "Confirmar pedido!".';
    _['CART.PAYMENT.WIRE_TRANSFER.REDIRECTING']='Confirmar pedido!';
    _['CART.PAYMENT.WIRE_TRANSFER.BTN']='Confirmar pedido!';
    _['CART.PAYMENT.REDSYS.ADVICE']='Serás redirecionado para a página do Redsys para realizar o pagamento.';
    _['CART.PAYMENT.REDSYS.REDIRECTING']='Redirecionando para Redsys';
    _['CART.PAYMENT.REDSYS.BTN']='¡Realizar o pagamento!';
    _['CART.PAYMENT.PICKATSTORE.BTN']='Confirmar pedido!';
    _['CART.PAYMENT.PICKATSTORE.ADVICE']='Confirma teu pedido. Analisa cuidadosamente todos os teus dados e pressione o botão "Confirmar pedido!".';

    _['CART.PAYMENT.ERR.SERVER.PREPARE.TITLE']='Erro no pagamento.';
    _['CART.PAYMENT.ERR.SERVER.PREPARE.MSG']='Ocorreu um erro ao efetuar o pagamento. Entre em contato com o administrador / Vendedor..';

    _['CART.PAYMENT.WIRE_TRANSFER.TEXT'] = 'Selecionastes o pagamento por transferência bancária. Em baixo, encontras as informações para efetuar o mesmo e o e-mail para o qual deves enviar o comprovativo da transferência.';
    _['CART.PAYMENT.WIRE_TRANSFER.BANK-ACCOUNT'] = 'Número de conta bancária';
    _['CART.PAYMENT.WIRE_TRANSFER.EMAIL'] = 'Email';

    _['CART.PAYMENT.SUCCESS.TITLE']='O teu pagamento foi recebido';
    _['CART.PAYMENT.SUCCESS.TITLE_RECEIVED']='O teu pedido foi recebido';
    _['CART.PAYMENT.SUCCESS.TITLE_WIRE_TRANSFER']='O teu pedido foi recebido';
    _['CART.PAYMENT.SUCCESS.MSG']='Obrigado pelo pagamento. A transação foi concluída e um e-mail com as informações da compra foi enviado para ti..';
    _['CART.PAYMENT.SUCCESS.MSG_RECEIVED']='Obrigado pelo teu pedido. Correu tudo bem e foi enviado um e-mail para ti com as informações do pedido.';
    _['CART.PAYMENT.SUCCESS.MSG_WIRE_TRANSFER']='Obrigado pelo teu pedido. Correu tudo bem e foi enviado um e-mail para ti com as informações do pedido.';
    _['CART.PAYMENT.FAILURE.TITLE']='Erro ao processar o pagamento';
    _['CART.PAYMENT.FAILURE.MSG']='Lamentamos, mas não conseguimos concluir a transação, porque ocorreu um erro ao processar o pagamento. Entra em contato com o teu administrador / vendedor.';
    _['CART.PAYMENT.SHIPPINGCHARGES.TITLE'] = 'Portes de envio';
    _['CART.PAYMENT.SHIPPINGCHARGES.FIXED'] = 'Portes de envio fixos';
    _['CART.PAYMENT.SHIPPINGCHARGES.MSG'] = 'Os portes de envio são gratuitos neste pedido.';
    _['CART.PAYMENT.PICKATSTOREOPTIONS.TITLE'] = 'Pegou na loja';
    _['CART.MIMINUMORDER'] = 'O pedido deve ser superior ao valor mínimo de ';

}(translations['pt']));



// WEBPACK FOOTER //
// ./src/app/modules/cart/lang/cart-lang_pt.js